import styles from "../../ConversionAndPdpViewer.module.css";
import {
  buildComparisonSubtext,
  formatCurrency,
  formatNumber,
  formatPct,
} from "./formatters";
import { MetricCard, SummaryBanner } from "./ui";

export default function WebsiteConversionTab({ data, currency = "USD" }) {
  const headline = data?.headlineMetrics || {};
  const rows = data?.stageMetricsTable || [];
  const comparisonLabel = null;

  return (
    <div className={styles.sectionStack}>
      <SummaryBanner
        title="Website conversion overview"
        text={
          data?.aiOverview ||
          data?.overview?.summary ||
          "Full funnel from website entry to purchase."
        }
        tone="warning"
      />

      <div className={styles.metricGrid5}>
        <MetricCard
          label="Website sessions"
          value={formatNumber(headline.websiteSessions)}
          subtext={comparisonLabel ? buildComparisonSubtext(headline.websiteSessions, headline.comparisonWebsiteSessions) : null}
        />
        <MetricCard
          label="PDP views"
          value={formatNumber(headline.pdpViews)}
          subtext={comparisonLabel ? buildComparisonSubtext(headline.pdpViews, headline.comparisonPdpViews) : null}
        />
        <MetricCard
          label="Add to cart"
          value={formatNumber(headline.addToCart)}
          subtext={comparisonLabel ? buildComparisonSubtext(headline.addToCart, headline.comparisonAddToCart) : null}
        />
        <MetricCard
          label="Checkout"
          value={formatNumber(headline.checkout)}
          subtext={comparisonLabel ? buildComparisonSubtext(headline.checkout, headline.comparisonCheckout) : null}
        />
        <MetricCard
          label="Purchase"
          value={formatNumber(headline.purchase)}
          subtext={comparisonLabel ? buildComparisonSubtext(headline.purchase, headline.comparisonPurchase) : null}
        />
      </div>

      {rows.length > 0 && (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>#</th>
                <th>Stage / Metric</th>
                <th className={styles.alignRight}>Value</th>
                {comparisonLabel ? <th className={styles.alignRight}>Compare</th> : null}
                <th>What it shows</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={row.key || index}>
                  <td>{index + 1}</td>
                  <td>{row.label}</td>
                  <td className={styles.alignRight}>
                    {row.type === "pct"
                      ? formatPct(row.value)
                      : row.type === "currency"
                        ? formatCurrency(row.value, currency)
                        : formatNumber(row.value)}
                  </td>
                  {comparisonLabel ? (
                    <td className={styles.alignRight}>
                      {row.comparisonValue == null
                        ? "—"
                        : row.type === "pct"
                          ? `${formatPct(row.comparisonValue)}`
                          : row.type === "currency"
                            ? `${formatCurrency(row.comparisonValue, currency)}`
                            : `${formatNumber(row.comparisonValue)}`}
                    </td>
                  ) : null}
                  <td>{row.explanation || row.whatItShows || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
